module.exports = __webpack_public_path__ + "static/img/sjgx.11d3454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sjgx.png
// module id = TSza
// module chunks = 1